// import {buildUserProfile} from '@/test/generate';
import searchResp from '../../apps/Studies/_mocks/search-response.json';

console.warn( '[Mocking] "studies" api' );

export default function ( instance ) {
    instance
        .onPost( '/requestinformation' )
        // Success Response
        .reply( () => ([
            200
        ]) );
    // Error Response
    // .reply( () => ([
    //     400,
    //     {
    //         message: 'Request information submission failed'
    //     }
    // ]) );

    instance
        .onGet( /\/search\?.*/ )
        .reply( () => ([
            200,
            searchResp
        ]) );

    instance
        .onGet( '/taxonomy' )
        .reply( () => ([
            200,
            [{
                'Name': 'Corporate',
                'Id': 'Corporate',
                'Children': [{'Name': 'Corporate Image', 'Id': 'Corporate Image'},
                    {'Name': 'Ultradent Logo', 'Id': 'Ultradent Logo'},
                    {'Name': 'Video', 'Id': 'Video'},
                    {'Name': 'Presentation', 'Id': 'Presentation'}]
            },
                {
                    'Name': 'Images',
                    'Id': 'Images',
                    'Children': [{'Name': 'Product Image', 'Id': 'Product Image'},
                        {'Name': 'Clinical photo', 'Id': 'Clinical photo'},
                        {'Name': 'Model', 'Id': 'Model'}]
                },
                {'Name': 'Regulatory', 'Id': 'Regulatory', 'Children': []},
                {
                    'Name': 'Sales & Marketing Material',
                    'Id': 'Sales & Marketing Material',
                    'Children': [{'Name': 'Brochure', 'Id': 'Brochure'},
                        {'Name': 'Flyer', 'Id': 'Flyer'},
                        {'Name': 'Advertisement', 'Id': 'Advertisement'},
                        {'Name': 'Branding & Logos', 'Id': 'Branding & Logos'},
                        {'Name': 'Poster', 'Id': 'Poster'},
                        {'Name': 'Sales sheet', 'Id': 'Sales sheet'},
                        {'Name': 'Presentation', 'Id': 'Presentation'},
                        {'Name': 'Video', 'Id': 'Video'},
                        {'Name': 'Catalog', 'Id': 'Catalog'}]
                },
                {
                    'Name': 'Training Material',
                    'Id': 'Training Material',
                    'Children': [{'Name': 'Video', 'Id': 'Video'}]
                }]
        ]) );
}
